import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; /* Includes base styles from index.css */
import "./styles/typography.css"; /* Teams type ramp tokens + base text size */
/* Emoji popup styles now in components.css */
import "./styles/centerEmojiPicker.js";
import "./styles/customStyles.css";
import "./styles/components.css";
import "./styles/pages.css";
import "./styles/motion.css"; /* keep last: shared transitions */
import "./styles/loaders.css"; /* loader overlays built on motion.css keyframes */
import "./styles/buttons.css"; /* shared button system */
import "./styles/utilities.css"; /* small shared utilities (Phase 3) */
import App from "./App";
import CallWindow from "./pages/CallWindow";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import { CrudProvider } from "@crud/react";
import { $crud } from "./helper/CrudFactory";
import { EditorProvider } from "react-simple-wysiwyg";
import { registerVoiceRecordingGlobals } from "./utils/voiceRecordingConstraints";
import { installArticleLinkClickInterceptor } from "./utils/articleLinkClickInterceptor";
import { initViewportHeight } from "./utils/viewportHeight";
import { captureIncomingDeeplink } from "./utils/startupScreen";

initViewportHeight();
registerVoiceRecordingGlobals();
installArticleLinkClickInterceptor();
captureIncomingDeeplink();

// The "/call" route runs Jitsi in its own browser tab. Mount only the
// lightweight standalone call page there — no sidebar, no app socket, no heavy
// app boot — so the main Kjuup tab is unaffected and stays usable during calls.
if (window.location.pathname === "/call") {
  ReactDOM.render(<CallWindow />, document.getElementById("root"));
} else {
  ReactDOM.render(
    <CrudProvider crud={$crud}>
      <BrowserRouter>
        <Provider store={store}>
          <React.StrictMode>
            <EditorProvider>
              <App />
            </EditorProvider>
          </React.StrictMode>
        </Provider>
      </BrowserRouter>
    </CrudProvider>,
    document.getElementById("root")
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
